import clsx from 'clsx'

interface StatusBadgeProps {
  status: string
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const normalized = status?.toLowerCase() || 'scheduled'
  const isLive = normalized === 'live' || normalized === 'in_progress'
  const isFinal = normalized === 'final'

  return (
    <span className={clsx(
      'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide',
      isFinal && 'bg-slate-700/50 text-slate-300',
      isLive && 'bg-red-500/20 text-red-400',
      !isFinal && !isLive && 'bg-accent/10 text-accent',
    )}>
      {isLive && (
        <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse-live" />
      )}
      {isFinal ? 'Final' : isLive ? 'Live' : 'Scheduled'}
    </span>
  )
}
